<template>
  <div>
    <h2 class="color">test ....{{msg}}</h2>
    <p class="color" @click="loadData">test ....{{getResponse}}....{{getResponse.status}}...{{getResponse.data}}</p>
    <table class="color" v-model="getResponse">
      <tr><td>{{getResponse.status}}</td></tr>
      <tr>{{getResponse.data}}</tr>
    </table>
    <p class="color" @click="tesUrlPostBody">test ....{{postDataBody}}</p>
  </div>
</template>

<script>
  import {testUrlGet,tesUrlPost,tesUrlPostBody} from "../../api/api";

  export default {
    name: "test",
    props:{
      msg:{
        type:String,
        default:"test msg"
      }
    },
    methods:{
      loadData: function() {
        testUrlGet({
          a: 11,
          b: 22
        }).then((x) =>{
          console.log(x);
          this.getResponse = x;
        })
      },
      tesUrlPost: function () {
        const res = tesUrlPost(this.postDataOne);
        console.log(res);
        res.then((x) => {
          console.log(x);
          this.resData = x;
        })
      },
      tesUrlPostBody: function () {
        const res = tesUrlPostBody(this.postDataBody);
        console.log(res);
        res.then((x) => {
          console.log(x);
          // this.$set(this.postDataBody,'keyword','change')
          this.postDataBody.keyword = "change";
          this.postDataBody.otherKeyword = "change2";
          // Object.assign({},this.person,{age:12,name:'wee'})
          // Object.assign({}, this.postDataBody, {keyword: 'change'})
          console.log(this.postDataBody);
        })
      }
    },
    created() {
      this.loadData()
      this.tesUrlPost()
      // this.tesUrlPostBody()
    },
    mounted(){
    },
    data(){
      return {
        success: "请求成功",
        fail: "请求失败",
        getResponse: {
          status: 200,
          data: {
          }
        },
        postDataOne: {
          aa: "aa",
          bb: "bb"
        },
        postDataBody: {
          keyword: "keyword",
          otherKeyword: "otherKeyword"
        },
        resData: {}
      }
    }
  }
</script>

<style scoped>
  .color{
    color: red;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/Test.vue